import { Stack, Text } from '@mantine/core'
import React from 'react'
import { useTheme } from '../../../components/ThemeProvider'

interface FailureComplyCaseProps {
  number: number
  item: any
}

const formatAmount = (amount: any) => {
  if (amount === '' || amount === null || amount === undefined) {
    return undefined
  }
  return `¥${amount}`
}

export default function FailureComplyCase({ number, item }: FailureComplyCaseProps) {
  const theme = useTheme()

  const headerFields = [
    { label: '案号', value: item?.caseCode },
    { label: '执行法院', value: item?.courtName },
    { label: '立案时间', value: item?.caseRegTime },
    { label: '发布时间', value: item?.casePublishTime },
    { label: '履行情况', value: item?.performanceStatus },
  ].filter((field) => field.value)

  const detailFields = [
    { label: '判决金额', value: formatAmount(item?.judgmentAmount) },
    { label: '履行内容', value: item?.obligation },
    { label: '失信行为', value: item?.dishonestBehavior },
  ].filter((field) => field.value)

  const extraFields = [
    { label: '所属地域', value: item?.areaName },
    { label: '执行依据文号', value: item?.executionBasisDocNo },
    { label: '执行依据单位', value: item?.executionBasisUnit },
  ].filter((field) => field.value)

  return (
    <div
      className="rounded-lg border px-4 py-4"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Stack gap="sm">
        <Text size="xs" c="dimmed">
          案件 {number}
        </Text>
        {headerFields.length > 0 && (
          <div className="grid gap-3 md:grid-cols-2">
            {headerFields.map((field) => (
              <FieldRow key={field.label} label={field.label} value={field.value} />
            ))}
          </div>
        )}
        {detailFields.length > 0 && (
          <div className="grid gap-3 md:grid-cols-2">
            {detailFields.map((field) => (
              <FieldRow key={field.label} label={field.label} value={field.value} />
            ))}
          </div>
        )}
        {extraFields.length > 0 && (
          <div className="grid gap-3 md:grid-cols-2">
            {extraFields.map((field) => (
              <FieldRow key={field.label} label={field.label} value={field.value} />
            ))}
          </div>
        )}
      </Stack>
    </div>
  )
}

interface FieldRowProps {
  label: string
  value?: string
}

function FieldRow({ label, value }: FieldRowProps) {
  return (
    <div className="flex flex-col gap-1">
      <Text size="xs" c="dimmed">
        {label}
      </Text>
      <Text size="sm" className="text-gray-700" fw={500}>
        {value || '—'}
      </Text>
    </div>
  )
}
